import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/professionals',
  title: 'Profissional',
  endpoint: '/app/professional',
}
